export const config = {
    bucketName: 'integraecommerce',
    region: 'eu-west-3',
    accessKeyId: process.env.REACT_APP_S3_ACCESS,
    secretAccessKey: process.env.REACT_APP_S3_SECRET,
    s3Url: 's3://arn:aws:s3:eu-west-3:929542092817:accesspoint/website', /* optional */
}